jQuery(document).ready(function($) {
    jQuery('.archive-single-button').on( 'click', function(e) {
        e.preventDefault();
    })
})